import React, { useState, useEffect } from 'react';
import { Tab, Tabs, Typography } from '@mui/material';
import { useNavigate, Link, useLocation } from "react-router-dom";
import { horizontalTabStyles } from '../sharedStyles';
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
    tabBody: {
        ...horizontalTabStyles.tabBody,
    }
}));

const RequestReviewSettingsTabs = ["b2busers", "customer", "employee", "tcicustomer"];

function RequestTypeWrapper(props) {
    const classes = useStyles();
    const {
        active,
        title,
        renderTabContent,
        routePath,
        additionalTab
    } = props;
    const [activeTab, setActiveTab] = useState(0)
    const navigate = useNavigate()
    const location = useLocation();
    const staticTabs = [
        { label: "B2B Users" },
        { label: "Customer" },
        { label: "Employee" },
        { label: "TCI Customer" }
    ]
        const allTabs = [...staticTabs, ...(additionalTab || []).map(item=>({
            label:item.display
        }))];
        const sortedTabs =allTabs.sort((a,b)=>a.label.localeCompare(b.label));
    let requestTypeTabs = RequestReviewSettingsTabs;
    if(additionalTab && additionalTab.length > 0){
        requestTypeTabs = [...requestTypeTabs, ...additionalTab.map((item)=>item.name)]
        
    }
     const sortedRequestTypeTabs =requestTypeTabs.sort((a,b)=>a.localeCompare(b));
    useEffect(() => {
        // Activating the Tab based on the tab param in the route url
        let activeTabIndex = sortedRequestTypeTabs.indexOf(active);

        // activating the first tab when the tab name does not match the list
        if (activeTabIndex < 0) {
            activeTabIndex = 0;
        }
        setActiveTab(activeTabIndex);
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[active])

    return (
        <>
            <Typography variant="h6" className='scopeHeader'>
                <Link color="primary" to={() => {
                    // Generating a Random Id and passing it as part of state 
                    // Every click on the Header will generate a unique Id
                    const autoId = Math.round(Math.random() * 1e5);
                    const subTab = RequestReviewSettingsTabs[activeTab];
                    return {
                        pathname: `/admin/${routePath}/` + subTab,
                        state: { fromredirection: autoId }
                    }
                }}
                >
                    {title}
                </Link>
            </Typography>
            <Tabs
                variant="scrollable"
                aria-label="tabs"
                value={activeTab >= 0 ? activeTab : 0}
                onChange={(_event, newValue) => {
                    setActiveTab(newValue);
                    // redirecting to the selected tab url so that refresh will retain in same page
                    navigate(`/admin/${routePath}/${sortedRequestTypeTabs[newValue]}`);
                }}
                sx={{ borderColor: 'divider' }}
            >
              
                {sortedTabs?.length > 0 && sortedTabs.map((item, i) => (<Tab key={item.label || i} label={item.label} />))}          
            </Tabs>
            <div className={classes.tabBody}>
            {activeTab >=0 && renderTabContent({
                activeTab: activeTab,
                activeRequestor: active,
                fromredirection: location?.state?.fromredirection,
                ...props
            })}
            </div>
        </>
    )
}
export default React.memo(RequestTypeWrapper);